const local = '_PROVIDER_PARAMETROS_FOLLOWAIR_'

var update = false

export default {
	methods: {
		_GET_PARAMETRO: function (callback) {
			this._httpGet('/Parametro/listar', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.parametro.length > 0 ? retorno.parametro : null)
				} else {
					callback(null)
				}
			})
		},

		_providerParametroUpdate: function (load) {
			if (load) {
				bus.$emit('load-in', {text: 'Atualizado cache'})
			}

			this._GET_PARAMETRO(function (lista) {
				if (load) {
					bus.$emit('load-out')
				}

				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerParametro: function (callback) {
			if (!update) {
				update = true
				this._GET_PARAMETRO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_PARAMETRO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}